export type VerificationStep = 'email' | 'phone'

const VT_TOKEN_KEY = 'verificationToken'
const VT_STEP_KEY = 'abk_vt_step'
const VT_EMAIL_KEY = 'abk_vt_email'
const VT_NAME_KEY = 'abk_vt_name'
const VT_SURNAME_KEY = 'abk_vt_surname'

export interface VerificationState {
  readonly token: string | null
  readonly step: VerificationStep | null
  readonly email: string | null
  readonly name: string | null
  readonly surname: string | null
}

export const getVerificationState = (): VerificationState => ({
  token: sessionStorage.getItem(VT_TOKEN_KEY),
  step: sessionStorage.getItem(VT_STEP_KEY) as VerificationStep | null,
  email: sessionStorage.getItem(VT_EMAIL_KEY),
  name: sessionStorage.getItem(VT_NAME_KEY),
  surname: sessionStorage.getItem(VT_SURNAME_KEY),
})

export interface SetVerificationOptions {
  readonly token: string
  readonly step: VerificationStep
  readonly email: string
  readonly name?: string
  readonly surname?: string
}

export const setVerificationState = ({
  token,
  step,
  email,
  name,
  surname,
}: SetVerificationOptions): void => {
  sessionStorage.setItem(VT_TOKEN_KEY, token)
  sessionStorage.setItem(VT_STEP_KEY, step)
  sessionStorage.setItem(VT_EMAIL_KEY, email)
  if (name) sessionStorage.setItem(VT_NAME_KEY, name)
  if (surname) sessionStorage.setItem(VT_SURNAME_KEY, surname)
}

export const updateVerificationStep = (step: VerificationStep): void => {
  sessionStorage.setItem(VT_STEP_KEY, step)
}

export const clearVerificationState = (): void => {
  sessionStorage.removeItem(VT_TOKEN_KEY)
  sessionStorage.removeItem(VT_STEP_KEY)
  sessionStorage.removeItem(VT_EMAIL_KEY)
  sessionStorage.removeItem(VT_NAME_KEY)
  sessionStorage.removeItem(VT_SURNAME_KEY)
}
